// const baseURL = 'http://localhost:8080';
const baseURL = 'https://jo-enmedia-flask-app-48730501420.us-central1.run.app';

export default baseURL;